import { Button, Form, Input, Layout, Tag } from "antd";
import React, { useCallback, useMemo, useState } from "react";
import { PlusCircleOutlined } from "@ant-design/icons/lib";
import CommonTableComponent from "../common-table-component";
import resources from "../../../resources";
import server from "../../../server";


const columns = [
    {
        title: 'Display Name',
        dataIndex: 'displayName',
        align: "left",
    },
    {
        title: 'Description',
        dataIndex: 'description',
        align: "left",
    },
    {
        title: 'Created On',
        key: 'createdOn',
        dataIndex: 'createdOn',
        show: true,
        render: (value: any) => value || "-",
    },
    {
        title: 'Created By',
        key: 'createdBy',
        dataIndex: 'createdBy',
        show: true,
    },
    {
        title: 'Updated On',
        key: 'updatedOn',
        dataIndex: 'updatedOn',
        render: (value: any) => value || "-",
        show: true,
    },
    {
        title: 'Updated By',
        key: 'updatedBy',
        dataIndex: 'updatedBy',
        show: true,
    },
    {
        title: 'Status',
        dataIndex: 'active',
        align: "left",
        render: (active: boolean) => (
            <Tag className={`status-pill ${active ? 'active' : 'inactive'}`}>
                {active ? 'Active' : 'Inactive'}
            </Tag>
        ),
    }
];

const Designation = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const tempResources = resources.commonButtonText;
    const designationColumn = columns;

    const fetchDesignations = useCallback(async (params?: any) => {
        try {
            const designations = params
                ? await server.settings.designation.list(params)
                : await server.settings.designation.list();
            const newDesignations = designations.map((designation: any) => ({
                ...designation,
            }))
            return newDesignations;
        } catch (e) {
            console.log(e);
            return [];
        }
    }, []);

    const propsData = useMemo(
        () => ({
            title: "Designation",
            create: server.settings.designation.create,
            getAll: fetchDesignations,
            delete: server.settings.designation.delete,
            update: server.settings.designation.updateStatus,
            isModalOpen: isModalOpen,
            setIsModalOpen: setIsModalOpen,
            updateDesignation: server.settings.designation.update,
            columns: designationColumn,
            deleteById: server.settings.designation.delete,
            showStatus: true,
            updateRecord: true,
            formFields: [
                <Form.Item
                    label="Code"
                    name={"code"}
                    rules={[{required: true, message: 'Please input Code!'}]}>
                    <Input placeholder={"Enter code"} name={"code"}/>
                </Form.Item>,
                <Form.Item
                    label="Description"
                    name="description"
                    rules={[{required: true, message: 'Please input Description!'}]}>
                    <Input placeholder={"Enter description"} name="description"/>
                </Form.Item>,
                <Form.Item
                    label="Display Name"
                    name="displayName"
                    rules={[{required: true, message: 'Please input Display Name!'}]}>
                    <Input placeholder={"Enter display name"} name="displayName"/>
                </Form.Item>,
            ],
            formFieldsType: [
                {name: "code", type: "code"},
                {name: "description", type: "string"},
                {name: "displayName", type: "string"},
            ],
            tableFieldsType: [
                {name: "code", type: "code"},
                {name: "description", type: "string"},
                {name: "status", type: "boolean"}
            ]
        }),
        [isModalOpen, setIsModalOpen, designationColumn, fetchDesignations]
    );

    return (
        <div className="settings-section">
            <div className={'settings-section__heading'}>
                <h4>Designation</h4>
                <Button type="primary"
                        icon={<PlusCircleOutlined/>}
                        onClick={() => setIsModalOpen(true)}
                        className="settings-section__action-button">
                    {tempResources.addButton}
                </Button>
            </div>

            <Layout className="settings-section__table-layout">
                <CommonTableComponent propsData={propsData}/>
            </Layout>
        </div>
    )
}

export default Designation;
